import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { SimplesNacionalOptantePipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        SimplesNacionalOptantePipe
    ],
    exports: [
        SimplesNacionalOptantePipe
    ]
})
export class SimplesNacionalModule { }
